module.exports = __webpack_public_path__ + "static/media/Maven_6740.f0527a98.jpg";